
import { ChangeDetectionStrategy, Component, forwardRef, ChangeDetectorRef, Input, ElementRef } from '@angular/core';
import { WizDropItemEvent, WIZ_DRAGGABLE_COMPONENT } from '@wizeoo/akm-component-lib';
import { WidgetConfigurationObj, WidgetConfigurationItemObj } from '@wizeoo/akm-message-lib';
import { FeiKeyDef, EM_ACTION, WizConstants } from '@wizeoo/akm-compute-lib';

import { FormWidgetGridsterComponent } from './generic/form-widget.gridster.component';
import { FeiVO } from '../../../vo/workingdata/fei.vo';
import { FormFieldObj } from '../../../manager/baselines/form-field.obj';
import { ViewData } from '../../../model/view.data';
import { GridsterWidgetItem } from '../../../vo/workingzone/gridster-widget-item';
import { IWidget } from '../../../manager/widgets/i-widget';

@Component({
  selector: 'baseline-gridster',
  template: `
  <div class ="wrapper" width="100%" height="100%">
    <gridster #gridster 
    [options]="options" width="100%" height="100%" class="gridster" [style.background-color]="_backgroundColor" tabindex="0">
      <gridster-item [item]="item" *ngFor="let item of filteredItems">
        <baseline-gridster-item 
          [widget]="widget"
          [model]="model"
          [field]="item"
              [templatingMode]="templatingMode"
              (update)="onItemUpdated($event)"
              (delete)="onItemDeleted($event)"></baseline-gridster-item>
      </gridster-item>
    </gridster>
  </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: WIZ_DRAGGABLE_COMPONENT,
      useExisting: forwardRef(() => BaselineGridsterComponent),
    },
  ],
  styleUrls: ['./generic/form-widget.gridster.component.scss']
})
export class BaselineGridsterComponent extends FormWidgetGridsterComponent {

  constructor(public el: ElementRef, cdref: ChangeDetectorRef) {
    super(cdref);
  }

  @Input() widget: IWidget;

  @Input() fei: FeiVO;

  @Input() context: WidgetConfigurationObj;

  @Input() 
  public restrictSet: Map<string, string>;

  @Input() 
  public hiddenGroups: Map<string, boolean>;

  // map des champs masqués par règles de gestion la clé est code|fdvf
  public hiddenMap: Map<string, any> = new Map();

  /**
   * filtrer les éléments en restrict
   */
  public get filteredItems(): GridsterWidgetItem[] {
    if(this.templatingMode) {
      return this.widgets;
    } else {
      let res: GridsterWidgetItem[] = [];
      
      let needRefreshCoords: boolean = false;

      // console.log('filteredItems',this.hiddenGroups, this.hiddenMap);


      this.widgets?.forEach(gwi => {

        let ffo: FormFieldObj = gwi.field as FormFieldObj;
        let code: string = ffo?.wcio.cod;
        let baseCode:string = code;
        let filterKey: string = [ffo?.wcio.cod, ffo?.wcio.fdvf].join(WizConstants.KEY_SEPARATOR);
        try {
          baseCode = code.split(WizConstants.CONTEXT_SEPARATOR)[0];
        } catch(e:any) {

        }
        

        // gestion des containers
        let group: string = ffo.wcio?.pgrp || null; // prise du groupe sur le ffr
        let groupHidden: boolean = false;
        
        if(!!group && baseCode !== ViewData.FORM_ZONE) { // on ne masque jamais les zones
          
          if(!!this.hiddenGroups?.get(group)) {
            groupHidden = true;
            // console.log('must be hidden', group, code);
          }
          
          // if(!!this.hiddenGroups?.get(group)) {
          //   groupHidden = true;
          //   //console.log('hidden',this.hiddenGroups, group, code, baseCode);
          // } else {
          //   // console.log('visible',this.hiddenGroups, group, code, baseCode);
          // }
        }
        
        if(this.restrictSet?.has(code) || groupHidden) {
          this.hiddenMap.set(filterKey, {x: gwi.x, y: gwi.y});
          //console.log('hidden', gwi, (this.widget as any)?.restrictSet);
          // res.push(gwi);
        } else { // doit être visible
          if(this.hiddenMap.has(filterKey)) { // il était caché, on refresh ses coordonnées
            let good: any = this.hiddenMap.get(filterKey);
            
            this.hiddenMap.delete(filterKey);
            needRefreshCoords = true;
            // TODO TODO attention doublon de champs: form vide
            // console.log(' waz hidden', code, good);
            /** alimentation des coordonnées */ 
              // gwi.x = good.x;
              // gwi.y = good.y;
          }
          // console.log('order', (gwi.field as PivotField)?.code);
          res.push(gwi);
        }  
      });

      // console.log('hidden', this.hiddenMap);


      if(needRefreshCoords) { // un item réapparait, il faut recalculer les places
         // this.options.compactType = 'none';
        this.options.api?.optionsChanged();
        this.widgets.forEach(gwiBad => {
          // console.log('1',(gwiBad.field as PivotField)?.code, gwiBad.x, gwiBad.y, gwiBad.source.x, gwiBad.source.y);
          gwiBad.x = gwiBad.source.x;
          gwiBad.y = gwiBad.source.y;
          //console.log('2', (gwiBad.field as PivotField)?.code, gwiBad.x, gwiBad.y, gwiBad.source.x, gwiBad.source.y);
        });
        this.widgets.sort((a,b) => {
          return this.calculatedTabIndex(a) - this.calculatedTabIndex(b);
        })
        // retour à vide, il va rincer ses éléments
        return [];   
      }
      return res;
    }

  }



  onAddItemAfterDrag(pEvent: WizDropItemEvent): void {

    const fkd: FeiKeyDef = pEvent.item.data;
    // enrichissement du wcio si libellé
    let wcio: WidgetConfigurationItemObj;
    // interception des champs de libellés
    if (fkd.code === ViewData.FORM_LABEL 
      || fkd.code === ViewData.FORM_TITLE 
      || fkd.code === ViewData.FORM_COMMENT  ) { // rendu custom sur FD
      wcio = this.model.widgetEngine.newWcio(fkd.code, 0);
      wcio.lbl = fkd.label;
    } else if (
      fkd.code === ViewData.FORM_ZONE 
      || fkd.code === ViewData.FORM_HTML 
      || fkd.code === ViewData.FORM_IMAGE 
      || fkd.code === ViewData.FORM_ACTION  ) { // rendu custom sur FD
      wcio = this.model.widgetEngine.newWcio(fkd.code, 0);
      wcio.lbl = fkd.label;
    } else {
      wcio = this.model.widgetEngine.newWcio(fkd.fullCode, 0);
    }
    

    const item: GridsterWidgetItem = GridsterWidgetItem.constructFromGridster(this.gridster.emptyCell.getValidItemFromEvent(pEvent.event));
    item.field = new FormFieldObj(this.widget, this.fei, wcio);
    item.source = wcio;
    item.updateCoords();
   
    this._widgets = [item, ...this._widgets];
    // console.log('onAddItemAfterDrag subGridster', item);
    this.widgetsChanged.emit({item, action: EM_ACTION.CREATE}); //this.widgetsChanged.emit(this._widgets);

    this.cdref.markForCheck();
  }

  checkDragOver(event: WizDropItemEvent): boolean {
    this.gridster.emptyCell.emptyCellDragOver(event.event);

    // console.log('drag', event);
    const fkd: FeiKeyDef = event.item.data;
    if (!fkd || fkd.isKey) {
      return true;
    }
    return !this._widgets.find(wo => wo.field.fkd?.fullCode === event.item.data?.fullCode) && event.event.dataTransfer.dropEffect !== 'none';
  }
}
